
// Import utils
import { isEmpty } from '@automator/shared/utils/is-empty';

/**
 * Finds a loop in the recipe using the loop ID.
 * This function clones the loop to avoid modifying the original object.
 *
 * @param {Number} loopID The loop ID
 * @return {Object} The loop
 * @throws Will throw an error if loopID is not defined or if the loop with the specified ID is not found.
 */
const getLoop = ( loopID ) => {
	if ( isEmpty( loopID ) ) {
		throw new Error( `getLoop: loopID must be defined` );
	}

	// Get the loop
	let loop = UncannyAutomator._recipe.actions.items.find( item => item.id === loopID );

	// Check if the loop exists
	if ( isEmpty( loop ) ) {
		throw new Error( `getLoop: loop with ID ${ loopID } not found` );
	}

	// Clone the loop to avoid modifying the original loop
	loop = structuredClone( loop );

	if ( loop?.iterable_expression?.type !== 'token' ) {
		return loop;
	}

	// Parse the fields and backup
	try {
		loop.iterable_expression.fields = JSON.parse( loop.iterable_expression.fields );
	} catch ( e ) {}

	try {
		loop.iterable_expression.backup = JSON.parse( loop.iterable_expression.backup );
	} catch ( e ) {}

	return loop;
}

export default getLoop;
